module.exports = __webpack_public_path__ + "static/powerbi-load-data-f7f0e66019075946e4c941d8b523acdc.gif";